import InvoiceDocument from "./invoice/InvoiceDocument";

/** Off-screen A4 render used for window.print() and html2pdf export. */
export default function InvoicePrintable({ inv }) {
  if (!inv) return null;
  return (
    <div className="invoice-print-root" style={{ position: "fixed", left: "-10000px", top: 0, width: "210mm", background: "#fff" }}>
      <div style={{ padding: "16mm" }}>
        <InvoiceDocument inv={inv} />
      </div>
    </div>
  );
}
